import React from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/core'
import { genUID } from '@entrata/utils'

const st0 = css`
  fill: #f2ebe6;
`
const st1 = css`
  fill: #fce5e7;
`
const st2 = css`
  fill: #dfe2e5;
`
const st3 = css`
  fill: #273e4f;
`

class Tools extends React.Component {
  constructor(props) {
    super(props)
    this.titleId = genUID()
  }

  render() {
    const {
      style = {},
      size = 16,
      height,
      width,
      svgRef,
      title,
      ...props
    } = this.props

    return (
      <svg
        viewBox='0 0 104 104'
        height={height || size}
        width={width || size}
        ref={svgRef}
        aria-labelledby={title ? this.titleId : undefined}
        style={{
          pointerEvents: 'none',
          fill: 'currentColor',
          ...style,
        }}
        {...props}
      >
        {title ? <title id={this.titleId}>{title}</title> : null}
        <path
          css={st0}
          d='M95,30.1c0,0,0.3,1.6,0,4.2c-0.3,2.5-6.7,4.9-8.6,7.4s8.5,56.8-4.7,56.8s-5-54-5-56.8s-2.8-3.3-6.5-5.3 c-3.7-2.1-2.2-6.2-2.2-6.2H95z'
        />
        <path
          css={st1}
          d='M5.3,93.5c0,2.8,2.2,5,5,5H21c2.8,0,5-2.2,5-5V49H5.3V93.5z M68,1.7v19.4h27.4V1.7H68z'
        />
        <path
          css={st2}
          d='M68,21.1v8h27v-8H68z M54.3,21.1c0,0,4.4-5,4.4-9.7c0-2.8-6.1-9.2-6.1-9.2S53,14,47.8,14 c-5.2,0-5.1-11.7-5.1-11.7s-6.1,6.4-6.1,9.2c0,4.6,4.4,10,4.4,10l0.1,56.4c0,0-5.1,8.6-4.6,11.7c0.4,2.6,6.7,8.1,6.7,8.1 S42.6,86,47.7,86c4.2,0,3.9,11.6,3.9,11.6s6.6-5.4,7.1-8.1c0.6-3.1-4.4-11.7-4.4-11.7V21.1z M13,2.2L10,10l1.8,5v32.2h7.7V14.4 l1.8-4.4l-3.5-7.7H13z'
        />
        <path
          css={st3}
          d='M12.4,53.1c-1,0-1.8,0.8-1.8,1.8v33.2c0,1,0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8V54.9C14.1,53.9,13.4,53.1,12.4,53.1 z M19.5,53.1c-1,0-1.8,0.8-1.8,1.8v33.2c0,1,0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8V54.9C21.3,53.9,20.5,53.1,19.5,53.1z M95.2,0H67.8 c-1,0-1.8,0.8-1.8,1.8v31.7c0.1,5.2,8.7,5.4,9.1,9.2c0.3,2.3-4.7,36.9-2.3,48.5c1.2,5.9,4.1,8.9,8.7,8.9c5.4,0,8-5.6,8.7-8.9 c2.4-11.6-2.5-46.4-2.3-48.5c0.3-3.6,9-4.2,9-9.2V1.8C97,0.8,96.2,0,95.2,0z M93.5,33.4c-1.1,3-9.2,3.2-9,9.6 c0.4,12.6,4.2,38.4,2.4,47.4c-0.1,0.2-1.3,6.1-5.3,6.1c-3.6,0-4.7-3.2-5.3-6.1C74.5,81.5,78,55.6,78.7,43c0.3-6-8.6-7-9.1-9.6v-2.1 h23.9V33.4z M93.5,27.8H69.6v-5h23.9V27.8z M93.5,19.3H69.6V3.5H71v2.2c0,1,0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8V3.5H78v0.4 c0,1,0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8V3.5h4.2v3.6c0,1,0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8V3.5h4.3V19.3z M81.6,93c1,0,1.8-0.8,1.8-1.8 s-0.8-1.8-1.8-1.8s-1.8,0.8-1.8,1.8S80.6,93,81.6,93z M60.6,12c0-5.1-3.1-9.9-7.8-11.9c-1.1-0.5-2.5,0.4-2.4,1.6v7.7l-2.5,2.3 l-2.2-2.3V1.8c0-1.2-1.3-2.1-2.4-1.6C38.3,2,35,6.7,35,12c0,3.7,1.7,7.3,4.5,9.7v56.5c-2.8,2.4-4.5,6-4.5,9.7 c0,5.2,3.1,9.9,7.8,11.9c1.1,0.5,2.5-0.4,2.4-1.6v-7.7l2.5-2.3l2.2,2.3v7.8c0,1.2,1.3,2.1,2.4,1.6c4.9-1.9,8.2-6.7,8.2-11.9 c0-3.7-1.7-7.3-4.5-9.7V21.7C58.9,19.3,60.6,15.7,60.6,12z M52.6,21.2c0,0.1,0,57.9,0,57.9c0,0.6,0.3,1.1,0.7,1.4 c2.4,1.7,3.8,4.5,3.8,7.5c0,2.9-1.4,5.6-3.6,7.3v-5.5c0-0.5-0.2-0.9-0.5-1.2l-3.9-4c-0.7-0.7-1.8-0.7-2.4-0.1l-4.3,4 c-0.4,0.3-0.6,0.8-0.6,1.3v5.4c-2-1.8-3.3-4.4-3.3-7.2c0-2.9,1.4-5.7,3.8-7.5c0.4-0.3,0.7-0.9,0.7-1.4c0,0,0-57.8,0-57.9 c0.1-0.6-0.1-1.3-0.7-1.7c-2.4-1.7-3.8-4.5-3.8-7.5c0-2.9,1.4-5.6,3.6-7.3v5.5c0,0.5,0.2,0.9,0.5,1.2l3.9,4c0.7,0.7,1.8,0.7,2.4,0.1 l4.3-4c0.4-0.3,0.6-0.8,0.6-1.3V4.9c2,1.8,3.3,4.4,3.3,7.1c0,2.9-1.4,5.7-3.8,7.5C52.8,19.9,52.5,20.6,52.6,21.2z M23.7,46.6h-2.5 V15.3l1.9-4.9c0.2-0.4,0.2-0.8,0-1.2l-3-8.1C19.9,0.5,19.2,0,18.5,0H13c-0.7,0-1.4,0.5-1.6,1.1l-3,8.1c-0.1,0.4-0.1,0.8,0,1.2 l1.9,4.9v31.2H7.8c-2.6,0-4.8,2.1-4.8,4.8v3.2c0,0.4,0.2,0.8,0.6,0.9c0.7,0.2,1.1,0.9,1.1,1.6c0,0.8-0.5,1.4-1.1,1.6 C3.2,58.9,3,59.2,3,59.6v30.2c0,5.5,4.5,10.2,9.8,10.2h5.9c5.3,0,9.8-4.7,9.8-10.2V59.6c0-0.4-0.2-0.8-0.6-0.9 c-0.7-0.2-1.1-0.9-1.1-1.6c0-0.8,0.5-1.4,1.1-1.6c0.4-0.1,0.6-0.5,0.6-0.9v-3.2C28.4,48.7,26.3,46.6,23.7,46.6z M14.2,3.5h3.1 l2.3,6.3l-1.8,4.6c-0.1,0.2-0.1,32.2-0.1,32.2h-4c0,0,0-32-0.1-32.2l-1.8-4.6L14.2,3.5z M24.9,54.5c0,0.4-0.2,0.8-0.6,0.9 c-0.7,0.2-1.1,0.9-1.1,1.6c0,0.8,0.5,1.4,1.1,1.6c0.4,0.1,0.6,0.5,0.6,0.9v30.2c0,3.6-2.9,6.7-6.2,6.7h-5.9c-3.3,0-6.2-3.1-6.2-6.7 V59.6c0-0.4,0.2-0.8,0.6-0.9c0.7-0.2,1.1-0.9,1.1-1.6c0-0.8-0.5-1.4-1.1-1.6c-0.4-0.1-0.6-0.5-0.6-0.9v-3.2c0-0.7,0.6-1.2,1.2-1.2 h15.9c0.7,0,1.2,0.6,1.2,1.2V54.5z M47.8,22.7c-1,0-1.8,0.8-1.8,1.8v51.6c0,1,0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8V24.5 C49.6,23.5,48.8,22.7,47.8,22.7z'
        />
      </svg>
    )
  }
}

Tools.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  svgRef: PropTypes.func,
  style: PropTypes.object,
  title: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
export { Tools }
